module.exports = __webpack_public_path__ + "static/media/Full_W_Article_Img.1af41661.jpg";